import React from "react";
import "./LearningManagementSystem.css";
import LMSystem from "../../assets/LearningManagementSystem/LearningManagementSystem.jpg";
import Features from "../../assets/LearningManagementSystem/LMS_features.jpg";
import LMS_Img from "../../assets/LearningManagementSystem/LMS.jpg";
import Lms_dashboard from "../../assets/LearningManagementSystem/LMS_Dashboard.jpg";
import Lms_mockUp from "../../assets/LearningManagementSystem/LMS_MockUp.jpg";
import Analyst_dashboard from "../../assets/LearningManagementSystem/Analyst_dashboard.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const LearningManagementSystem = () => {
  return (
    <div className="learning-management-system">
      <div className="lms-main">
        <div className="lms-text-container">
          <h2 className="lms-title">
            <b>Empowering Minds: <br /> Where Learning Meets Innovation.</b>
          </h2>
          <p className="lms-description">
            Gain the experience of unlocking the modification of education and
            creativity with the help of our solutions. Come into a place where
            the professional meets the inspirational, and the creativity knows
            no limits. Reefberg is ready to serve the needs of learners,
            teachers, and creators alike along with the use of modern
            technologies that transform tomorrow.
          </p>
        </div>
        <img src={LMSystem} className="lms-image" alt="Learning Management System" />
      </div>

      <div className="features-main">
        <div className="features-image-container">
          <img src={Features} className="features-image" alt="LMS Features" />
        </div>
        <div className="features-text-container">
          <h3 className="features-title">Features</h3>
          <ul className="features-list">
            <li className="feature-item">
              <b>Course Creation Without Limits</b>
              <p>
                <KeyboardDoubleArrowRightIcon />
                Plan, update and offer courses in a simplified manner.
              </p>
            </li>
            <li className="feature-item">
              <b>Industry Guided Direction</b>
              <p>
                <KeyboardDoubleArrowRightIcon />
                Use business intelligence strategies to create evidence-based
                strategies.
              </p>
            </li>
            <li className="feature-item">
              <b>Enhanced Methods of Teaching</b>
              <p>
                <KeyboardDoubleArrowRightIcon />
                Testing, discussions, and sound and video content for improving
                access to education.
              </p>
            </li>
            <li className="feature-item">
              <b>Responsive Design</b>
              <p>
                <KeyboardDoubleArrowRightIcon />
                Responsive design ensures access to the latest courses
                irrespective of location.
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="lms-slider-container">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          spaceBetween={20}
          slidesPerView={1}
          loop={true}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
        >
          {[LMS_Img, Lms_dashboard, Lms_mockUp, Analyst_dashboard].map((img, idx) => (
            <SwiperSlide key={idx}>
              <div className="slider-slide">
                <img src={img} className="slider-image" alt={`Slide ${idx + 1}`} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default LearningManagementSystem;
